/* -------------------------------------------------------------------------
 * urso-thumb-variant-sync.js
 * Secao "urso-product-main": clicar numa miniatura da galeria passa a
 * selecionar a variante correspondente (pill de sabor), nao so trocar a foto.
 *
 * O caminho inverso (variante -> foto) ja e feito por urso-pmain.js.
 *
 * Como casa miniatura com variante: o Liquid gera as duas URLs com a mesma
 * transformacao (image_url: width: 1600), entao thumb[data-full] === variant.img.
 * ------------------------------------------------------------------------- */
(function () {
  if (window.__ursoThumbVariantSync) return;
  window.__ursoThumbVariantSync = true;

  function pathOf(url) {
    if (!url) return '';
    var s = String(url);
    var q = s.indexOf('?');
    return q === -1 ? s : s.slice(0, q);
  }

  function sectionData(root) {
    var el = document.getElementById('upm-data-' + root.getAttribute('data-sid'));
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function activeValues(root) {
    var chosen = {};
    root.querySelectorAll('.urso-pmain__pills').forEach(function (g) {
      var act = g.querySelector('.urso-pmain__pill.is-active');
      if (act) chosen[Number(g.getAttribute('data-opt-pos')) - 1] = act.getAttribute('data-value');
    });
    return chosen;
  }

  // Varias variantes podem usar a mesma foto: preferir a que mantem as
  // outras opcoes ja escolhidas, e depois a que estiver disponivel.
  function score(variant, chosen) {
    var total = 0;
    for (var k in chosen) {
      if (variant.opts[Number(k)] === chosen[k]) total += 1;
    }
    if (variant.av) total += 0.5;
    return total;
  }

  function syncFromThumb(thumb) {
    var root = thumb.closest('.urso-pmain[data-sid]');
    if (!root) return;

    var data = sectionData(root);
    if (!data || !data.variants || !data.variants.length) return;

    var full = thumb.getAttribute('data-full');
    var fullPath = pathOf(full);
    var candidates = data.variants.filter(function (v) {
      return v.img && (v.img === full || pathOf(v.img) === fullPath);
    });
    if (!candidates.length) return; // midia que nao pertence a nenhuma variante

    var chosen = activeValues(root);
    var best = candidates[0];
    candidates.forEach(function (v) {
      if (score(v, chosen) > score(best, chosen)) best = v;
    });

    root.querySelectorAll('.urso-pmain__pills').forEach(function (group) {
      var index = Number(group.getAttribute('data-opt-pos')) - 1;
      var wanted = best.opts[index];
      if (wanted === undefined || wanted === null) return;

      var target = null;
      group.querySelectorAll('.urso-pmain__pill').forEach(function (pill) {
        if (pill.getAttribute('data-value') === wanted) target = pill;
      });
      if (!target || target.classList.contains('is-active')) return;

      // Dispara o handler nativo do tema: atualiza preco, disponibilidade,
      // rotulo da opcao, barra fixa e a variante usada no add-to-cart.
      target.click();
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var node = event.target;
      if (!node || !node.closest) return;
      var thumb = node.closest('.urso-pmain__thumb');
      if (!thumb) return;
      syncFromThumb(thumb);
    },
    true
  );
})();
